import styled, { css, keyframes } from 'styled-components';
import { select, withQuery } from '../../core/themev2';
import { getNeutralColors, getOrangeColors } from '../theme';
import { BodyText2Css, ButtonText2Css } from '../typography';

const fadeIn = keyframes`
  from {
    opacity: 0;
    bottom: -48px;
  }
  to {
    opacity: 1;
    bottom: 40px;
  }
`;

const fadeInMobile = elevate => keyframes`
  from {
    opacity: 0;
    bottom: -40px;
  }
  to {
    opacity: 1;
    bottom: ${elevate ? 120 : 20}px;
  }
`;

const SnackbarContainer = styled.div`
  background-color: ${getNeutralColors('black')};
  ${({ type }) => type === 'DANGER' && `background-color: ${select('negative')}`}
  ${({ type }) => type === 'SUCCESS' && `background-color: ${select('snackGreen')}`}
  ${({ type }) => type === 'WARNING' && `background-color: ${select('darkYellow')}`}
  border-radius: 4px;
  bottom: -48px;
  color: ${getNeutralColors('white')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: auto;
  margin: 0;
  max-width: 100%;
  opacity: 0;
  padding: 1.3rem 1.6rem;
  position: fixed;
  transition: opacity 0.5s;
  visibility: ${({ toggleSnack }) => (toggleSnack ? 'visible' : 'hidden')};
  z-index: 9999;
  &:hover {
    cursor: pointer;
  }
  &.isActive {
    animation: ${fadeIn} 0.5s ease-out forwards;
    opacity: 1;
    ${withQuery.sm.down()} {
      animation: ${props => fadeInMobile(props.elevate)} 0.5s ease-out forwards;
    }
  }
  > div {
    ${BodyText2Css}
    max-width: 582px;
    padding-right: 10px;
    white-space: break-spaces;
  }
  > span {
    ${ButtonText2Css}
    color: ${getOrangeColors('base')};
  }
  @media ${({ theme }) => theme.v2.breakpoints.Max.tablet} {
    width: calc(100% - 40px);
    left: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ${props =>
      props.isLong &&
      css`
        > div {
          padding-bottom: 18px;
        }
        > span {
          align-self: flex-end;
        }
      `}
  }
`;

const SnackContainer = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0;
`;

export { SnackbarContainer, SnackContainer };
